import ApiClient from './ApiClient';

class MotorReservaRoomRatesAPI extends ApiClient {
  constructor() {
    super('motor_reserva_room_rates', { accountScoped: true });
  }

  massCombine(combinations) {
    return axios.post(`${this.url}/mass_combine`, { combinations });
  }
}

export default new MotorReservaRoomRatesAPI();
